// React & Router
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// HTTP client
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// Bootstrap components
import { Container, Row, Col, Breadcrumb, Image } from 'react-bootstrap';

// RSuite components
import {
    VStack, HStack, Stack,
    Input, Text,
    ButtonToolbar, Button, IconButton,
    Whisper, Tooltip,
    SelectPicker, Table, Pagination,
    Uploader, Panel, Modal, Loader
} from 'rsuite';

// Thai date picker
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class EducationPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            year: '',
            loading: false,
            modal: null,
            preview: null,
            eduSortColumn: '',
            eduSortType: '',
            eduLimit: 10,
            eduPage: 1,
            edu_level: '',
            curr_institution: '',
            curr_field: '',
            educationData: [],
            education_level: '',
            year_level: '',
            school_name: '',
            start_year: '',
            end_year: '',
            study_field: '',
            gpax: '',
            grade_feeling: '',
            files: [],
            internPage: 1,
            internSortColumn: '',
            internSortType: '',
            internLimit: 10,
            internPage: 1,
            internshipData: [],
            intern_position: '',
            intern_dept: '',
            intern_company: '',
            company_address: '',
            intern_start_date: '',
            intern_end_date: '',
            intern_details: '',
        };
    }

    async componentDidMount() {
        const logged = JSON.parse(localStorage.getItem('logged') || '{}');
        const token = logged?.user?.token;

        if (!token) {
            return (window.location.href = '/login');
        }

        const authHeader = {
            headers: { Authorization: `Bearer ${token}` }
        };

        await this.promisedSetState({ authHeader });

        try {
            await this.onRenderContent({ mode: 'read' });
        } catch (error) {
            if (error.response?.status === 401) {
                window.location.href = '/login';
            } else {
                // จัดการ error อื่น ๆ ตามปกติ
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        }
    }

    // Promise-based setState
    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    handleDateChange = (value) => {
        this.setState({ date_start: value });
    };

    getEducationPaginatedData = () => {
        if (!this.state.educationData) return [];

        const { eduSortColumn, eduSortType, eduLimit, eduPage } = this.state;

        let data = [...this.state.educationData];

        if (eduSortColumn && eduSortType) {
            data.sort((a, b) => {
                let x = a[eduSortColumn];
                let y = b[eduSortColumn];

                if (typeof x === 'string' && typeof y === 'string') {
                    return eduSortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
                }

                return eduSortType === 'asc' ? x - y : y - x;
            });
        }

        const start = eduLimit * (eduPage - 1);
        const end = start + eduLimit;
        return data.slice(start, end);
    };

    getInternshipPaginatedData = () => {
        if (!this.state.internshipData) return [];

        const { internSortColumn, internSortType, internLimit, internPage } = this.state;

        let data = [...this.state.internshipData];

        if (internSortColumn && internSortType) {
            data.sort((a, b) => {
                let x = a[internSortColumn];
                let y = b[internSortColumn];

                if (typeof x === 'string' && typeof y === 'string') {
                    return internSortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
                }

                return internSortType === 'asc' ? x - y : y - x;
            });
        }

        const start = internLimit * (internPage - 1);
        const end = start + internLimit;

        return data.slice(start, end);
    };

    onRenderContent = async ({ mode }) => {
        if (mode !== 'read') return;

        try {
            // เริ่มโหลด
            await this.promisedSetState({ loading: true });

            const { Column, HeaderCell, Cell } = Table;

            // ดึง ID ผู้ใช้จาก localStorage
            const id = JSON.parse(localStorage.getItem('logged') || '{}')?.user?.user?.id;

            if (!id) {
                throw new Error("ไม่พบข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบใหม่");
            }

            // ดึงข้อมูลล่าสุดจาก API
            let data = null;
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API}/application/latest/${id}`,
                    this.state.authHeader
                );
                data = response.data;
            } catch (apiError) {
                throw new Error("ไม่สามารถดึงข้อมูลจากเซิร์ฟเวอร์");
            }

            // อัปเดต state จากข้อมูล API
            await this.promisedSetState({
                edu_level: data?.edu_level || '',
                curr_institution: data?.curr_institution || '',
                curr_field: data?.curr_field || '',
            });

            // ดึงข้อมูล education ทั้งหมดจาก API
            const educationRes = await axios.get(`${process.env.REACT_APP_API}/education/applicant/${id}`, this.state.authHeader);
            const educationApiData = educationRes.data;

            const mappedEducationData = (Array.isArray(educationApiData) ? educationApiData : [educationApiData]).map(item => ({
                id: item.id,
                yearStart: item.start_year ? item.start_year.toString() : '',
                yearEnd: item.end_year ? item.end_year.toString() : '',
                classLevel: item.year_level || '',
                school_name: item.school_name || '',
                schoolAddress: '',
                program: item.study_field || '',
                gpax: item.gpax || null,
            }));

            await this.promisedSetState({
                educationData: mappedEducationData,
                eduPage: 1 // รีเซ็ตหน้าเวลาโหลดใหม่
            });

            const getEducationPaginatedData = this.getEducationPaginatedData();

            // ดึงข้อมูล internship ทั้งหมดจาก API
            const internRes = await axios.get(`${process.env.REACT_APP_API}/internship/applicant/${id}`, this.state.authHeader);
            const internshipApiData = internRes.data;

            const monthNamesThai = [
                'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
            ];

            function formatDateThaiShort(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                if (isNaN(date)) return '';

                const day = date.getDate();
                const month = monthNamesThai[date.getMonth()];
                const year = (date.getFullYear() + 543) % 100; // ปี พ.ศ. สองหลัก

                return `${day} ${month} ${year}`;
            }

            const mappedInternshipData = (Array.isArray(internshipApiData) ? internshipApiData : [internshipApiData]).map(item => ({
                id: item.id,
                internStartDate: formatDateThaiShort(item.intern_start_date) || "",
                internEndDate: formatDateThaiShort(item.intern_end_date) || "",
                position: item.intern_position || "",
                company: item.intern_company || "",
            }));

            await this.promisedSetState({
                internshipData: mappedInternshipData,
                internPage: 1,
            });

            const getInternshipPaginatedData = this.getInternshipPaginatedData();

            // แสดงเนื้อหาทั้งหมดใน content
            await this.promisedSetState({
                content: (
                    <>
                        {/* Breadcrumb */}
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg'>
                                    <Breadcrumb.Item>
                                        <Link to="/admin"><i className="bi bi-house-fill"></i></Link>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>ประวัติการศึกษา</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        {/* Panel: สถานะการศึกษาปัจจุบัน */}
                        <Row>
                            <Col lg={12} className='mb-3'>
                                <Panel header="สถานะการศึกษาปัจจุบัน" className="shadow-sm" style={{ backgroundColor: '#FFF', padding: '1em' }}>
                                    <Row className='mt-3'>
                                        <Col>
                                            <Stack wrap spacing={6}>
                                                <label>ระดับการศึกษาที่ศึกษาอยู่ <span style={{ color: 'red' }}>*</span></label>
                                                <SelectPicker
                                                    className='pXHMB'
                                                    size='lg'
                                                    data={[
                                                        { value: 'มัธยมศึกษาปีที่ 6', label: 'มัธยมศึกษาปีที่ 6' },
                                                        { value: 'ประกาศนียบัตรวิชาชีพ (ปวช.) ปีที่ 3', label: 'ประกาศนียบัตรวิชาชีพ (ปวช.) ปีที่ 3' },
                                                        { value: 'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) ปีที่ 2', label: 'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) ปีที่ 2' },
                                                    ]}
                                                    searchable={false}
                                                    style={{ width: 300 }}
                                                    placeholder="กรุณาเลือกรายการ"
                                                    defaultValue={this.state.edu_level}
                                                    onChange={e => this.setState({ edu_level: e })}
                                                    onClean={() => this.setState({ edu_level: '' })}
                                                />
                                            </Stack>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col lg={4} className='mb-3'>
                                            <VStack>
                                                <label>สถานศึกษา ณ ปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                <Input
                                                    className='GXvbA'
                                                    size='sm'
                                                    defaultValue={this.state.curr_institution}
                                                    onChange={e => this.setState({ curr_institution: e })}
                                                />
                                            </VStack>
                                        </Col>
                                        <Col lg={3} className='mb-3'>
                                            <VStack>
                                                <label>สาย/สาขาที่เรียนในปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                <Input
                                                    className='1K1iv'
                                                    size='sm'
                                                    defaultValue={this.state.curr_field}
                                                    onChange={e => this.setState({ curr_field: e })}
                                                />
                                            </VStack>
                                        </Col>
                                    </Row>

                                    <HStack justifyContent="flex-end" style={{ width: '100%' }}>
                                        <Button
                                            size='sm'
                                            appearance="primary"
                                            startIcon={<i className="bi bi-floppy-fill"></i>}
                                            onClick={() => this.onConfirm({ form: 'present', mode: 'update', id: data.id })}
                                        >
                                            บันทึก
                                        </Button>
                                    </HStack>
                                </Panel>
                            </Col>
                        </Row>

                        {/* Panel: ประวัติการศึกษา */}
                        <Row className='mt-2'>
                            <Col lg={12} className='mb-3'>
                                <Panel header="ประวัติการศึกษา" className="shadow-sm" style={{ backgroundColor: '#FFF', padding: '1em' }}>
                                    <Button
                                        className='mt-2'
                                        size='sm'
                                        startIcon={<i className="bi bi-plus-lg"></i>}
                                        color="green"
                                        appearance="primary"
                                        onClick={() => this.onModalEducation({ mode: 'insert', id })}
                                    >
                                        เพิ่ม
                                    </Button>

                                    <Row className='mt-2'>
                                        <Col>
                                            <Table
                                                autoHeight
                                                data={getEducationPaginatedData}
                                                bordered
                                                cellBordered
                                                className='shadow-sm'
                                                sortColumn={this.state.eduSortColumn}
                                                sortType={this.state.eduSortType}
                                                onSortColumn={(sortColumn, sortType) => {
                                                    this.promisedSetState({ eduSortColumn: sortColumn, eduSortType: sortType, eduPage: 1 })
                                                        .then(() => this.onRenderContent({ mode: "read" }));
                                                }}
                                            >
                                                <Column width={180} sortable resizable>
                                                    <HeaderCell align='center'>ปีการศึกษา</HeaderCell>
                                                    <Cell dataKey="yearStart">
                                                        {rowData => (
                                                            <div style={{ textAlign: 'center' }}>
                                                                {rowData.yearStart} - {rowData.yearEnd}
                                                            </div>
                                                        )}
                                                    </Cell>
                                                </Column>

                                                <Column width={180} align='center' resizable>
                                                    <HeaderCell>ระดับการศึกษา</HeaderCell>
                                                    <Cell dataKey="classLevel" />
                                                </Column>

                                                <Column width={350} resizable>
                                                    <HeaderCell>ชื่อโรงเรียน/สถาบัน</HeaderCell>
                                                    <Cell dataKey="school_name" />
                                                </Column>

                                                <Column width={305} resizable>
                                                    <HeaderCell>สาย/สาขาวิชาที่เรียน</HeaderCell>
                                                    <Cell dataKey="program" />
                                                </Column>

                                                <Column width={122} align='center' sortable resizable>
                                                    <HeaderCell>GPAX</HeaderCell>
                                                    <Cell dataKey="gpax" />
                                                </Column>

                                                <Column width={105} align="center" fixed="right">
                                                    <HeaderCell>...</HeaderCell>
                                                    <Cell style={{ padding: '6px' }}>
                                                        {rowData => (
                                                            <ButtonToolbar>
                                                                <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                    <IconButton size='sm' color="yellow" appearance="primary"
                                                                        icon={<i className="bi bi-pencil-square"></i>}
                                                                        onClick={async () => {
                                                                            await this.promisedSetState({ changePassword: false, password: '', confirm_password: '' });
                                                                            await this.onModalEducation({ mode: 'update', id: rowData.id });
                                                                        }}
                                                                    />
                                                                </Whisper>
                                                                <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                    <IconButton size='sm' color="red" appearance="primary"
                                                                        icon={<i className="bi bi-trash-fill"></i>}
                                                                        onClick={() => this.onConfirm({ form: 'edu', mode: 'delete', id: rowData.id })}
                                                                    />
                                                                </Whisper>
                                                            </ButtonToolbar>
                                                        )}
                                                    </Cell>
                                                </Column>
                                            </Table>

                                            <div style={{ padding: 20 }}>
                                                <Pagination
                                                    prev
                                                    next
                                                    first
                                                    last
                                                    ellipsis
                                                    boundaryLinks
                                                    maxButtons={5}
                                                    size="xs"
                                                    layout={["total", "|", "pager"]}
                                                    total={this.state.educationData ? this.state.educationData.length : 0}
                                                    limit={this.state.eduLimit}
                                                    activePage={this.state.eduPage}
                                                    onChangePage={async page => {
                                                        await this.promisedSetState({ eduPage: page });
                                                        await this.onRenderContent({ mode: "read" });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Panel>
                            </Col>
                        </Row>

                        {/* Panel: ประวัติการฝึกงาน */}
                        <Row className='mt-2'>
                            <Col lg={12} className='mb-3'>
                                <Panel header="ประวัติการฝึกงาน" className="shadow-sm" style={{ backgroundColor: '#FFF', padding: '1em' }}>
                                    <Button
                                        className='mt-2'
                                        size='sm'
                                        startIcon={<i className="bi bi-plus-lg"></i>}
                                        color="green"
                                        appearance="primary"
                                        onClick={() => this.onModalIntern({ mode: 'insert', id: id })}
                                    >
                                        เพิ่ม
                                    </Button>

                                    <Row className='mt-2'>
                                        <Col>
                                            <Table
                                                autoHeight
                                                data={getInternshipPaginatedData}
                                                bordered
                                                cellBordered
                                                className='shadow-sm'
                                                sortColumn={this.state.internSortColumn}
                                                sortType={this.state.internSortType}
                                                onSortColumn={(sortColumn, sortType) => {
                                                    this.promisedSetState({ internSortColumn: sortColumn, internSortType: sortType, internPage: 1 })
                                                        .then(() => this.onRenderContent({ mode: "read" }));
                                                }}
                                            >
                                                <Column width={160} sortable resizable>
                                                    <HeaderCell align="center">วันที่เริ่มงาน</HeaderCell>
                                                    <Cell align="center" dataKey="internStartDate" />
                                                </Column>

                                                <Column width={160} sortable resizable>
                                                    <HeaderCell align="center">วันที่สิ้นสุด</HeaderCell>
                                                    <Cell align="center" dataKey="internEndDate" />
                                                </Column>

                                                <Column width={320} resizable>
                                                    <HeaderCell>ตำแหน่ง</HeaderCell>
                                                    <Cell dataKey="position" />
                                                </Column>

                                                <Column width={482} resizable>
                                                    <HeaderCell>ชื่อบริษัทหรือหน่วยงาน</HeaderCell>
                                                    <Cell dataKey="company" />
                                                </Column>

                                                <Column width={120} align="center" fixed="right">
                                                    <HeaderCell>...</HeaderCell>
                                                    <Cell style={{ padding: '6px' }}>
                                                        {rowData => (
                                                            <ButtonToolbar>
                                                                <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                    <IconButton size='sm' color="yellow" appearance="primary"
                                                                        icon={<i className="bi bi-pencil-square"></i>}
                                                                        onClick={async () => {
                                                                            await this.promisedSetState({ changePassword: false, password: '', confirm_password: '' });
                                                                            await this.onModalIntern({ mode: 'update', id: rowData.id });
                                                                        }}
                                                                    />
                                                                </Whisper>
                                                                <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                    <IconButton size='sm' color="red" appearance="primary"
                                                                        icon={<i className="bi bi-trash-fill"></i>}
                                                                        onClick={() => this.onConfirm({ form: 'intern', mode: 'delete', id: rowData.id })}
                                                                    />
                                                                </Whisper>
                                                            </ButtonToolbar>
                                                        )}
                                                    </Cell>
                                                </Column>
                                            </Table>

                                            <div style={{ padding: 20 }}>
                                                <Pagination
                                                    prev
                                                    next
                                                    first
                                                    last
                                                    ellipsis
                                                    boundaryLinks
                                                    maxButtons={5}
                                                    size="xs"
                                                    layout={["total", "|", "pager"]}
                                                    total={this.state.internshipData ? this.state.internshipData.length : 0}
                                                    limit={this.state.internLimit}
                                                    activePage={this.state.internPage}
                                                    onChangePage={async page => {
                                                        await this.promisedSetState({ internPage: page });
                                                        await this.onRenderContent({ mode: "read" });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Panel>
                            </Col>
                        </Row>
                    </>
                )
            });

            // ปิดโหลด
            this.setState({ loading: false });

        } catch (error) {
            console.error('เกิดข้อผิดพลาด:', error.message || error);
            window.location.href = '/login';
        }
    };

    onUpload = (obj) => {
        if (obj.method === 'insert') {
            this.setState(prevState => ({
                files: [...prevState.files, {
                    files: {
                        mode: 'inserting',
                        file_id: null,
                        key: obj.key,
                        name: obj.event.name,
                        mimetype: obj.response.mimetype,
                        file_data: obj.response.buffer
                    }
                }]
            }))
        } else if (obj.method === 'delete') {
            this.state.files
                .filter(res => res.files.key === obj.key)
                .map(item => item.files.mode = 'deleting')
        }
    }

    bufferToBlob = (obj) => {
        const byteArray = new Uint8Array(obj.data)
        return new Blob([byteArray], { type: obj.mimetype })
    }

    onPreview = async (obj) => {
        const { type, url, data, name } = obj;

        const imageTypes = ['jpg', 'jpeg', 'png', 'gif'];
        const videoTypes = ['mp4', 'webm', 'ogg'];
        const audioTypes = ['mp3', 'wav', 'ogg'];

        let modalContent;

        // ฟังก์ชันช่วยแปลง base64 เป็น Uint8Array
        const base64ToUint8Array = (base64) => {
            const raw = atob(base64);
            const uint8Array = new Uint8Array(raw.length);
            for (let i = 0; i < raw.length; i++) {
                uint8Array[i] = raw.charCodeAt(i);
            }
            return uint8Array;
        };

        switch (type) {
            case 'pdf': {
                try {
                    let blobUrl;

                    if (data) {
                        let pdfBlob;

                        if (typeof data === 'string') {
                            // ถ้า data เป็น base64 ที่อาจจะมี prefix "data:application/pdf;base64,"
                            const base64Prefix = 'data:application/pdf;base64,';
                            if (data.startsWith(base64Prefix)) {
                                const base64Data = data.slice(base64Prefix.length);
                                const pdfData = base64ToUint8Array(base64Data);
                                pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
                            } else {
                                // ถ้าเป็น base64 ธรรมดา
                                const pdfData = base64ToUint8Array(data);
                                pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
                            }
                        } else if (data instanceof ArrayBuffer || data instanceof Uint8Array) {
                            pdfBlob = new Blob([data], { type: 'application/pdf' });
                        } else {
                            throw new Error('ข้อมูล PDF ไม่ถูกต้อง');
                        }

                        blobUrl = URL.createObjectURL(pdfBlob);
                    } else if (url) {
                        // fallback ใช้ url ถ้าไม่มี data
                        blobUrl = url;
                    } else {
                        throw new Error('ไม่พบข้อมูล PDF');
                    }

                    modalContent = (
                        <iframe
                            src={blobUrl}
                            width="100%"
                            height="500"
                            title={name}
                            style={{ border: 'none' }}
                        />
                    );
                } catch (error) {
                    console.error('PDF preview error:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถเปิดไฟล์ PDF ได้',
                        text: error.message || '',
                        confirmButtonText: 'ตกลง',
                    });
                    return; // ออกจากฟังก์ชัน ไม่ต้องแสดง Modal
                }
                break;
            }

            case 'txt':
            case 'csv':
            case 'json':
                modalContent = (
                    <pre style={{ maxHeight: 400, overflow: 'auto', whiteSpace: 'pre-wrap' }}>
                        {typeof data === 'string' ? data : JSON.stringify(data, null, 2)}
                    </pre>
                );
                break;

            default:
                if (imageTypes.includes(type)) {
                    modalContent = <Image width="100%" height="100%" src={url} rounded />;
                } else if (videoTypes.includes(type)) {
                    modalContent = (
                        <video controls width="100%" height="auto">
                            <source src={url} type={`video/${type}`} />
                            Your browser does not support the video tag.
                        </video>
                    );
                } else if (audioTypes.includes(type)) {
                    modalContent = (
                        <audio controls>
                            <source src={url} type={`audio/${type}`} />
                            Your browser does not support the audio element.
                        </audio>
                    );
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: `<div style="font-size: 1.4rem; line-height: 1.5;">ไม่สามารถ Preview</div>`,
                        confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                        timer: 1500,
                    });
                    return; // ออกจากฟังก์ชัน
                }
        }

        await this.promisedSetState({
            preview: (
                <Modal size="md" open={true} onClose={() => this.setState({ preview: [] })}>
                    <Modal.Header>
                        <Modal.Title>{name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalContent}</Modal.Body>
                </Modal>
            ),
        });
    };

    onDownload = (obj) => {
        fetch(obj.url)
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.download = obj.fileName || "downloaded-file";
                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            });
    }

    onModalEducation = async ({ mode, id, sel }) => {
        const getAdmissionYears = () => {
            const currentYear = new Date().getFullYear() + 543;
            return Array.from({ length: 101 }, (_, i) => {
                const year = currentYear - i;
                return { label: year.toString(), value: year.toString() };
            });
        };

        const getGradesByEducationLevel = (level) => {
            const map = {
                'ระดับประถมศึกษา': ['ป.1', 'ป.2', 'ป.3', 'ป.4', 'ป.5', 'ป.6'],
                'ระดับมัธยมศึกษา': ['ม.1', 'ม.2', 'ม.3', 'ม.4', 'ม.5', 'ม.6'],
                'ระดับอาชีวศึกษา': ['ปวช.1', 'ปวช.2', 'ปวช.3'],
                'ระดับอุดมศึกษา': ['ปี 1', 'ปี 2', 'ปี 3', 'ปี 4'],
                'ระดับการศึกษานอกระบบ': ['ม.ต้น กศน.', 'ม.ปลาย กศน.', 'การศึกษาตามอัธยาศัย', 'หลักสูตรระยะสั้น']
            };
            return (map[level] || []).map(v => ({ value: v, label: v }));
        };

        const admissionYears = getAdmissionYears();

        if (mode === 'insert' && !sel) {
            await this.promisedSetState({ education_level: '', year_level: '', school_name: '', start_year: '', end_year: '', study_field: '', gpax: '', grade_feeling: '', files: [] });
            this.defaultFileList = []
        }

        if (mode === 'update' && !sel) {
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_API}/education/${id}`, this.state.authHeader);
                await this.promisedSetState({
                    education_level: data.education_level || '',
                    year_level: data.year_level || '',
                    school_name: data.school_name || '',
                    start_year: data.start_year || '',
                    end_year: data.end_year || '',
                    study_field: data.study_field || '',
                    gpax: data.gpax || '',
                    grade_feeling: data.grade_feeling || '',
                    files: []
                });

                const resFiles = await axios.get(`${process.env.REACT_APP_API}/education/uploads/${id}`, this.state.authHeader);
                this.defaultFileList = resFiles.data.map(item => ({
                    name: item.originalname
                    , fileKey: item.id
                    , url: `${process.env.REACT_APP_UPLOAD}/${item.path}`
                }));
                this.setState({
                    files: resFiles.data.map(item => ({
                        files: {
                            mode: 'reading'
                            , file_id: item.id
                            , key: item.id
                            , name: item.filename
                            , mimetype: item.mimetype
                            , file_data: null
                        }
                    }))
                });
            } catch (err) { console.error("Error fetching education data:", err); }
        }

        await this.promisedSetState({
            modal: <Modal size={'md'} backdrop={'static'} keyboard={false} open={true}
                onClose={() => this.setState({ modal: null })}>
                <Modal.Header><Modal.Title>ข้อมูลประวัติการศึกษา</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col lg={5} className='mb-3'>
                                <VStack>
                                    <label>ระดับการศึกษา <span style={{ color: 'red' }}>*</span></label>
                                    <SelectPicker
                                        className='gT2mP'
                                        size='lg'
                                        data={['ระดับประถมศึกษา', 'ระดับมัธยมศึกษา', 'ระดับอาชีวศึกษา', 'ระดับอุดมศึกษา', 'ระดับการศึกษานอกระบบ'].map(v => ({ value: v, label: v }))}
                                        defaultValue={this.state.education_level}
                                        searchable={false}
                                        style={{ width: 300 }}
                                        placeholder="กรุณาเลือกรายการ"
                                        onChange={async (value) => {
                                            await this.promisedSetState({ education_level: value, year_level: '' });
                                            await this.onModalEducation({ mode, id, sel: true });
                                        }}
                                        onClean={() => this.setState({ education_level: '', year_level: '' })}
                                    />
                                </VStack>
                            </Col>
                            <Col lg={3} className='mb-3'>
                                <VStack>
                                    <label>ชั้นปี <span style={{ color: 'red' }}>*</span></label>
                                    <SelectPicker
                                        className='xR9qL'
                                        size='lg'
                                        data={getGradesByEducationLevel(this.state.education_level)}
                                        defaultValue={this.state.year_level}
                                        searchable={false}
                                        style={{ width: 180 }}
                                        placeholder="กรุณาเลือก"
                                        disabled={!this.state.education_level}
                                        onChange={(value) => this.setState({ year_level: value })}
                                        onClean={() => this.setState({ year_level: '' })}
                                    />
                                </VStack>
                            </Col>
                        </Row>

                        <Row>
                            <Col className='mb-3'>
                                <VStack>
                                    <label>ชื่อโรงเรียน / สถาบัน <span style={{ color: 'red' }}>*</span></label>
                                    <Input 
                                    className='vK8dW'
                                    size='sm' 
                                    defaultValue={this.state.school_name} 
                                    onChange={e => this.setState({ school_name: e })} />
                                </VStack>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={4} className='mb-3'>
                                <VStack>
                                    <label>ปีที่เข้าศึกษา <span style={{ color: 'red' }}>*</span></label>
                                    <SelectPicker 
                                    className='mL3yB'
                                        size='lg' 
                                        data={admissionYears} 
                                        defaultValue={this.state.start_year}
                                        searchable={false} style={{ width: 180 }} placeholder="กรุณาเลือก"
                                        onChange={e => this.setState({ start_year: e })} onClean={() => this.setState({ start_year: '' })} />
                                </VStack>
                            </Col>
                            <Col lg={4} className='mb-3'>
                                <VStack>
                                    <label>ปีที่จบการศึกษา </label>
                                    <SelectPicker size='lg' data={admissionYears} defaultValue={this.state.end_year}
                                        searchable={false} style={{ width: 180 }} placeholder="กรุณาเลือก"
                                        onChange={e => this.setState({ end_year: e })} onClean={() => this.setState({ end_year: '' })} />
                                </VStack>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={6} className='mb-3'>
                                <VStack>
                                    <label>สาย/สาขาที่เรียน <span style={{ color: 'red' }}>*</span></label>
                                    <Input className='pN1vX' size='sm' defaultValue={this.state.study_field} onChange={e => this.setState({ study_field: e })} />
                                </VStack>
                            </Col>
                            <Col lg={3} className='mb-3'>
                                <VStack>
                                    <label>เกรดเฉลี่ยสะสม (GPAX) <span style={{ color: 'red' }}>*</span></label>
                                    <Input className='sJ7rM' size='sm' defaultValue={this.state.gpax} onChange={e => this.setState({ gpax: e })} />
                                </VStack>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <label>รู้สึกอย่างไรกับเกรดในเทอมนี้ <span style={{ color: 'red' }}>*</span></label>
                                <Input as="textarea" rows={3} className='qE4cZ' defaultValue={this.state.grade_feeling} onChange={e => this.setState({ grade_feeling: e })} />
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <label>แนบไฟล์ เช่น ผลการศึกษา (Transcript) วุฒิการศึกษา หรือใบรับรองรางวัล <span style={{ color: 'red' }}>*</span></label>
                                <Uploader
                                    action={`${process.env.REACT_APP_API}/files`}
                                    headers={this.state.authHeader}
                                    draggable
                                    fileList={this.defaultFileList}
                                    renderFileInfo={(file) => (
                                        file.url ? (
                                            <Stack wrap spacing={6}>
                                                <Text onClick={() => this.onPreview({ url: file.url, type: file.url.split('.').pop() })} color="blue">{file.name}</Text>
                                                <IconButton size='sm' circle icon={<i className="bi bi-download"></i>} appearance="default"
                                                    onClick={() => this.onDownload({ url: file.url, fileName: file.name })} />
                                            </Stack>
                                        ) : (
                                            <Stack wrap spacing={6}>{file.name}</Stack>
                                        )
                                    )}
                                    onSuccess={(o, e) => this.onUpload({ method: 'insert', key: e.fileKey, response: o, event: e })}
                                    onRemove={(e) => this.onUpload({ method: 'delete', key: e.fileKey })}
                                >
                                    <div style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span>คลิ๊กหรือลากไฟล์เพื่ออัปโหลด</span>
                                    </div>
                                </Uploader>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button size='sm' startIcon={<i className="bi bi-floppy-fill"></i>} appearance="primary"
                        onClick={() => this.onConfirm({ form: 'edu', mode, id })}>บันทึก</Button>
                    <Button size='sm' appearance="subtle" onClick={() => this.setState({ modal: null })}>ยกเลิก</Button>
                </Modal.Footer>
            </Modal>
        });
    };

    onModalIntern = async ({ mode, id, sel }) => {

        let data;

        if (!sel) {
            data = {
                intern_start_date: '',
                intern_end_date: '',
                intern_position: '',
                intern_dept: '',
                intern_company: '',
                company_address: '',
                intern_details: ''
            };

            if (mode === 'update') {
                const response = await axios.get(`${process.env.REACT_APP_API}/internship/${id}`, this.state.authHeader);
                const item = response.data;
                data = {
                    intern_start_date: item.intern_start_date || '',
                    intern_end_date: item.intern_end_date || '',
                    intern_position: item.intern_position || '',
                    intern_dept: item.intern_dept || '',
                    intern_company: item.intern_company || '',
                    company_address: item.company_address || '',
                    intern_details: item.intern_details || ''
                };
            }

            await this.promisedSetState(data);
        }

        await this.promisedSetState({
            modal: (
                <Modal
                    size={'md'}
                    backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>ข้อมูลประวัติการฝึกงาน</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col lg={4}>
                                    <VStack className="mb-3">
                                        <label>วันที่เริ่มงาน</label>
                                        <div className='wF9sM' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.intern_start_date}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async (e) => {
                                                    await this.promisedSetState({ intern_start_date: e });
                                                    await this.onModalIntern({ mode, id, sel: true });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ intern_start_date: '' });
                                                    await this.onModalIntern({ mode, id, sel: true });
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{ borderRadius: '0 6px 6px 0' }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>

                                <Col lg={4}>
                                    <VStack className="mb-3">
                                        <label>วันที่สิ้นสุดงาน</label>
                                        <div className='jP5xQ' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.intern_end_date}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async (e) => {
                                                    await this.promisedSetState({ intern_end_date: e });
                                                    await this.onModalIntern({ mode, id, sel: true });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ intern_end_date: '' });
                                                    await this.onModalIntern({ mode, id, sel: true });
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{ borderRadius: '0 6px 6px 0' }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <label>ตำแหน่ง <span style={{ color: 'red' }}>*</span></label>
                                    <Input
                                        className='nD4zR'
                                        size='sm'
                                        defaultValue={this.state.intern_position}
                                        onChange={e => this.setState({ intern_position: e })}
                                    />
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <label>แผนก / ฝ่าย  <span style={{ color: 'red' }}>*</span></label>
                                    <Input
                                        className='hT6pL'
                                        size='sm'
                                        defaultValue={this.state.intern_dept}
                                        onChange={e => this.setState({ intern_dept: e })}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={5} className='mb-3'>
                                    <label>ชื่อบริษัทหรือหน่วยงาน  <span style={{ color: 'red' }}>*</span></label>
                                    <Input
                                        className='eK3qW'
                                        size='sm'
                                        defaultValue={this.state.intern_company}
                                        onChange={e => this.setState({ intern_company: e })}
                                    />
                                </Col>
                                <Col lg={7} className='mb-3'>
                                    <label>ที่อยู่บริษัท  <span style={{ color: 'red' }}>*</span></label>
                                    <Input
                                        className='rB1nY'
                                        size='sm'
                                        defaultValue={this.state.company_address}
                                        onChange={e => this.setState({ company_address: e })}
                                    />
                                </Col>
                            </Row>

                            <Row className='mb-3'>
                                <Col>
                                    <label>รายละเอียดงาน <span style={{ color: 'red' }}>*</span></label>
                                    <Input
                                        className='tM2kZ'
                                        as="textarea"
                                        rows={3}
                                        defaultValue={this.state.intern_details}
                                        onChange={e => this.setState({ intern_details: e })}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            size='sm'
                            startIcon={<i className="bi bi-floppy-fill"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ form: 'intern', mode, id })}
                        >
                            บันทึก
                        </Button>
                        <Button
                            size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        });
    };

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ form, mode, id }) => {
        // ===== Validate EDU Present =====
        const validatePresent = async () => {
            const validationPromises = [
                this.Validate(this.state.edu_level, 'pXHMB', ''),
                this.Validate(this.state.curr_institution, 'GXvbA', ''),
                this.Validate(this.state.curr_field, '1K1iv', ''),
            ];

            const results = await Promise.all(validationPromises);
            return results.every(result => result === true);
        };

        // ===== Validate EDU =====
        const validateEdu = async () => {
            const validationPromises = [
                this.Validate(this.state.education_level, 'gT2mP', ''),
                this.Validate(this.state.year_level, 'xR9qL', ''),
                this.Validate(this.state.school_name, 'vK8dW', ''),
                this.Validate(this.state.start_year, 'mL3yB', ''),
                this.Validate(this.state.study_field, 'pN1vX', ''),
                this.Validate(this.state.gpax, 'sJ7rM', ''),
                this.Validate(this.state.grade_feeling, 'qE4cZ', ''),
            ];

            const results = await Promise.all(validationPromises);
            return results.every(result => result === true);
        };

        // ===== Validate INTERN =====
        const validateIntern = async () => {
            const validationPromises = [
                this.Validate(this.state.intern_activity, 'cX7vA', ''),
                this.Validate(this.state.intern_position, 'nD4zR', ''),
                this.Validate(this.state.intern_dept, 'hT6pL', ''),
                this.Validate(this.state.intern_company, 'eK3qW', ''),
                this.Validate(this.state.company_address, 'rB1nY', ''),
                this.Validate(this.state.intern_start_date, 'wF9sM', ''),
                this.Validate(this.state.intern_details, 'tM2kZ', ''),
            ];

            const results = await Promise.all(validationPromises);
            if (!results.every(result => result === true)) return false;

            // ✅ วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด
            const start = new Date(this.state.intern_start_date);
            const end = new Date(this.state.intern_end_date);
            if (start > end) {
                Swal.fire({
                    title: "วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
                return false;
            }

            return true;
        };

        // ===== Handle form === 'present' =====
        if (form === 'present') {
            const isValid = await validatePresent();
            if (!isValid) return;

            this.setState({ loading: true });

            try {
                if (mode === 'update') {
                    const formData = new FormData();
                    formData.append('id', id);
                    ['edu_level', 'curr_institution', 'curr_field'].forEach(key =>
                        formData.append(key, this.state[key] || '')
                    );

                    const response = await axios.patch(
                        `${process.env.REACT_APP_API}/application`,
                        formData,
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = '/login';
                } else {
                    // จัดการ error อื่น ๆ ตามปกติ
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                }
            }

            this.setState({ loading: false });
        }

        // ===== Handle form === 'edu' =====
        else if (form === 'edu') {
            // กรณี delete ข้าม validate
            if (mode === 'delete') {
                this.setState({ loading: true });

                Swal.fire({
                    title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                    cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const response = await axios.delete(
                                `${process.env.REACT_APP_API}/education/${id}`,
                                this.state.authHeader
                            );

                            const data = response.data;

                            if (data.message === 'successfully') {
                                Swal.fire({
                                    title: "ลบข้อมูลเรียบร้อยแล้ว",
                                    icon: "success",
                                    timer: 2000,
                                    timerProgressBar: true,
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                }).then(async () => {
                                    await this.onRenderContent({ mode: 'read' });
                                    this.setState({ modal: null });
                                });
                            } else {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาดในการลบ",
                                    text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                    icon: "error",
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                });
                            }
                        } catch (error) {
                            if (error.response?.status === 401) {
                                window.location.href = '/login';
                            } else {
                                // จัดการ error อื่น ๆ ตามปกติ
                                Swal.fire({
                                    title: 'เกิดข้อผิดพลาด',
                                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                    icon: 'error',
                                    confirmButtonText: 'ตกลง'
                                });
                            }
                        }
                    }
                });

                this.setState({ loading: false });
                return; // จบการทำงานเลย
            }

            // สำหรับ insert / update ต้อง validate
            const isValid = await validateEdu();
            if (!isValid) return;

            this.setState({ loading: true });

            try {
                if (mode === 'insert') {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API}/education`,
                        {
                            applicants_id: id,
                            education_level: this.state.education_level,
                            year_level: this.state.year_level,
                            school_name: this.state.school_name,
                            start_year: this.state.start_year,
                            end_year: this.state.end_year,
                            study_field: this.state.study_field,
                            gpax: this.state.gpax,
                            grade_feeling: this.state.grade_feeling,
                        },
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        let message = 0;

                        for (let i = 0; i < this.state.files.length; i++) {
                            const file = this.state.files[i].files;
                            if (file.mode === 'inserting') {
                                const formData = new FormData();
                                formData.append('id', data.data.id);
                                formData.append('file_name', file.name);
                                formData.append('file_data', this.bufferToBlob({ mimetype: file.mimetype, data: file.file_data.data }));

                                try {
                                    const uploadResponse = await axios.post(`${process.env.REACT_APP_API}/education/uploads`, formData, this.state.authHeader);
                                    if (uploadResponse.data.message === 'successfully') {
                                        message++;
                                    }
                                } catch (error) {
                                    if (error.response?.status === 401) {
                                        window.location.href = '/login';
                                    } else {
                                        // จัดการ error อื่น ๆ ตามปกติ
                                        Swal.fire({
                                            title: 'เกิดข้อผิดพลาด',
                                            text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                            icon: 'error',
                                            confirmButtonText: 'ตกลง'
                                        });
                                    }
                                }
                            } else if (file.mode === 'deleting' && file.file_id !== null) {
                                try {
                                    const deleteResponse = await axios.delete(`${process.env.REACT_APP_API}/education/uploads/${file.file_id}`, this.state.authHeader);
                                    if (deleteResponse.data.message === 'successfully') {
                                        message++;
                                    }
                                } catch (error) {
                                    if (error.response?.status === 401) {
                                        window.location.href = '/login';
                                    } else {
                                        // จัดการ error อื่น ๆ ตามปกติ
                                        Swal.fire({
                                            title: 'เกิดข้อผิดพลาด',
                                            text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                            icon: 'error',
                                            confirmButtonText: 'ตกลง'
                                        });
                                    }
                                }
                            } else {
                                message++;
                            }
                        }

                        if (message === this.state.files.length) {
                            Swal.fire({
                                title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.promisedSetState({
                                    education_level: '',
                                    year_level: '',
                                    school_name: '',
                                    start_year: '',
                                    end_year: '',
                                    study_field: '',
                                    gpax: '',
                                    grade_feeling: ''
                                });
                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        }
                    }
                } else if (mode === 'update') {
                    const formData = new FormData();
                    formData.append('id', id);
                    formData.append('education_level', this.state.education_level);
                    formData.append('year_level', this.state.year_level);
                    formData.append('school_name', this.state.school_name);
                    formData.append('start_year', this.state.start_year);
                    formData.append('end_year', this.state.end_year);
                    formData.append('study_field', this.state.study_field);
                    formData.append('gpax', this.state.gpax);
                    formData.append('grade_feeling', this.state.grade_feeling);

                    const response = await axios.patch(
                        `${process.env.REACT_APP_API}/education`,
                        formData,
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        let message = 0;

                        for (let i = 0; i < this.state.files.length; i++) {
                            const file = this.state.files[i].files;
                            if (file.mode === 'inserting') {
                                const formData = new FormData();
                                formData.append('id', id);
                                formData.append('file_name', file.name);
                                formData.append('file_data', this.bufferToBlob({ mimetype: file.mimetype, data: file.file_data.data }));

                                try {
                                    const uploadResponse = await axios.post(`${process.env.REACT_APP_API}/education/uploads`, formData, this.state.authHeader);
                                    if (uploadResponse.data.message === 'successfully') {
                                        message++;
                                    }
                                } catch (error) {
                                    if (error.response?.status === 401) {
                                        window.location.href = '/login';
                                    } else {
                                        // จัดการ error อื่น ๆ ตามปกติ
                                        Swal.fire({
                                            title: 'เกิดข้อผิดพลาด',
                                            text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                            icon: 'error',
                                            confirmButtonText: 'ตกลง'
                                        });
                                    }
                                }
                            } else if (file.mode === 'deleting' && file.file_id !== null) {
                                try {
                                    const deleteResponse = await axios.delete(`${process.env.REACT_APP_API}/education/uploads/${file.file_id}`, this.state.authHeader);
                                    if (deleteResponse.data.message === 'successfully') {
                                        message++;
                                    }
                                } catch (error) {
                                    if (error.response?.status === 401) {
                                        window.location.href = '/login';
                                    } else {
                                        // จัดการ error อื่น ๆ ตามปกติ
                                        Swal.fire({
                                            title: 'เกิดข้อผิดพลาด',
                                            text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                            icon: 'error',
                                            confirmButtonText: 'ตกลง'
                                        });
                                    }
                                }
                            } else {
                                message++;
                            }
                        }

                        if (message === this.state.files.length) {
                            Swal.fire({
                                title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.promisedSetState({
                                    education_level: '',
                                    year_level: '',
                                    school_name: '',
                                    start_year: '',
                                    end_year: '',
                                    study_field: '',
                                    gpax: '',
                                    grade_feeling: ''
                                });
                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        }
                    }
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = '/login';
                } else {
                    // จัดการ error อื่น ๆ ตามปกติ
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                }
            }

            this.setState({ loading: false });
        }

        // ===== Handle form === 'intern' =====
        else if (form === 'intern') {

            // กรณี delete ข้าม validate
            if (mode === 'delete') {
                this.setState({ loading: true });

                Swal.fire({
                    title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                    cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const response = await axios.delete(
                                `${process.env.REACT_APP_API}/internship/${id}`,
                                this.state.authHeader
                            );

                            const data = response.data;

                            if (data.message === 'successfully') {
                                Swal.fire({
                                    title: "ลบข้อมูลเรียบร้อยแล้ว",
                                    icon: "success",
                                    timer: 2000,
                                    timerProgressBar: true,
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                }).then(async () => {
                                    await this.onRenderContent({ mode: 'read' });
                                    this.setState({ modal: null });
                                });
                            } else {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาดในการลบ",
                                    text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                    icon: "error",
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                });
                            }
                        } catch (error) {
                            if (error.response?.status === 401) {
                                window.location.href = '/login';
                            } else {
                                // จัดการ error อื่น ๆ ตามปกติ
                                Swal.fire({
                                    title: 'เกิดข้อผิดพลาด',
                                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                    icon: 'error',
                                    confirmButtonText: 'ตกลง'
                                });
                            }
                        }
                    }
                });

                this.setState({ loading: false });
                return; // จบการทำงานเลย
            }

            const isValid = await validateIntern();
            if (!isValid) return;

            this.setState({ loading: true });

            try {
                if (mode === 'insert') {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API}/internship`, {
                        applicants_id: id,
                        intern_start_date: this.state.intern_start_date || '',
                        intern_end_date: this.state.intern_end_date || '',
                        intern_position: this.state.intern_position || '',
                        intern_dept: this.state.intern_dept || '',
                        intern_company: this.state.intern_company || '',
                        company_address: this.state.company_address || '',
                        intern_details: this.state.intern_details || ''
                    }, this.state.authHeader);

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                intern_start_date: '',
                                intern_end_date: '',
                                intern_position: '',
                                intern_dept: '',
                                intern_company: '',
                                company_address: '',
                                intern_details: ''
                            });
                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }
                } else if (mode === 'update') {
                    const response = await axios.patch(
                        `${process.env.REACT_APP_API}/internship`, {
                        id: id,
                        intern_start_date: this.state.intern_start_date || '',
                        intern_end_date: this.state.intern_end_date || '',
                        intern_position: this.state.intern_position || '',
                        intern_dept: this.state.intern_dept || '',
                        intern_company: this.state.intern_company || '',
                        company_address: this.state.company_address || '',
                        intern_details: this.state.intern_details || ''
                    }, this.state.authHeader);

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                intern_start_date: '',
                                intern_end_date: '',
                                intern_position: '',
                                intern_dept: '',
                                intern_company: '',
                                company_address: '',
                                intern_details: ''
                            });
                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = '/login';
                } else {
                    // จัดการ error อื่น ๆ ตามปกติ
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                }
            }

            this.setState({ loading: false });
        }
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.preview}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
